module.exports = __webpack_public_path__ + "img/190.0bc804e6.jpg";